import { useState } from 'react';

import { DriverTripPackageCards } from './DriverTripPackageCards';
import { DriverTripPackageTable } from './DriverTripPackageTable';
import { DriverVehiclesCards } from './DriverVehiclesCards';
import { DriverVehiclesTable } from './DriverVehiclesTable';
import { Tab, Tabs } from '../../components/Tab';
import { constants } from '../../constants';
import { t } from '../../services/translation/translation';
import { TripCards } from '../_authenticated._main.trips/TripCards';
import { TripTable } from '../_authenticated._main.trips/TripTable';

type Props = {
  driverKey: string;
};

export type DriverTabs = 'trips' | 'trip-packages' | 'vehicles';

const items: Tab<DriverTabs>[] = [
  { id: 'trips', label: t('side-bar.trips') },
  { id: 'trip-packages', label: t('side-bar.trips-packages') },
  { id: 'vehicles', label: t('side-bar.vehicles') },
];

export const DriverMultiTables = ({ driverKey }: Props) => {
  const [currentTab, setCurrentTab] = useState<DriverTabs>('trips');

  return (
    <div>
      <div className="mb-3">
        <Tabs
          // {/* TODO: Remove .filter when ready for production */}
          items={items.filter(item => (constants.isProd ? item.id !== 'trip-packages' : true))}
          onChange={id => setCurrentTab(id)}
        />
      </div>
      {currentTab === 'trips' ? (
        <div>
          <div className="hidden xl:block">
            <TripTable driverKey={driverKey} />
          </div>
          <div className="xl:hidden ">
            <TripCards driverKey={driverKey} />
          </div>
        </div>
      ) : currentTab === 'trip-packages' ? (
        <div>
          <div className="hidden xl:block">
            <DriverTripPackageTable driverKey={driverKey} />
          </div>
          <div className="xl:hidden ">
            <DriverTripPackageCards driverKey={driverKey} />
          </div>
        </div>
      ) : currentTab === 'vehicles' ? (
        <div>
          <div className="hidden xl:block">
            <DriverVehiclesTable />
          </div>
          <div className="xl:hidden ">
            <DriverVehiclesCards />
          </div>
        </div>
      ) : null}
    </div>
  );
};
